import React from 'react';
import Accordian from '../../../../components/Accordian';
import img1 from '../../../../img/how-signup-works/1.jpg';
import img2 from '../../../../img/how-signup-works/2.jpg';
import img3 from '../../../../img/how-signup-works/3.jpg';
import img4 from '../../../../img/how-signup-works/4.jpg';
import img5 from '../../../../img/how-signup-works/5.jpg';
import img6 from '../../../../img/how-signup-works/6.jpg';
import img7 from '../../../../img/how-signup-works/7.jpg';

const items = [
  {
    id: 1,
    title: 'Getting started',
    description: 'From the Home page, click on the big green ‘Start Learning for Free Now’ button or from anywhere on the website, the ‘Get Started’ button in the top-right hand corner.',
    image: img1
  },
  {
    id: 2,
    title: 'I want to learn BSL for...',
    description: 'Choose whether you are learning for fun or work and leave it to our website to help you choose the correct plan created by our team of BSL teaching experts.',
    image: img2
  },
  {
    id: 3,
    title: 'My current level is...',
    description: 'Choose your current signing skills so the plan can begin with a course you need to do next.',
    image: img3
  },
  {
    id: 4,
    title: 'I want to be signing at...',
    description: 'Select the Level at which you wish to eventually be signing at. This will be the last course in the plan we create for you.',
    image: img4
  },
  {
    id: 5,
    title: 'One final thing...',
    description: 'In order for the plan to be created and to take you straight to your student account, enter your name and email address.',
    image: img5
  },
  {
    id: 6,
    title: 'Student dashboard',
    description: 'Your student dashboard is where everything will be as well as show you all the other courses we offer and any discounts we offer throughout the year.',
    image: img6
  },
  {
    id: 7,
    title: 'Start learning!',
    description: 'This is where all your course material are that you can access anytime, anywhere; on your computer or your mobile device. You will have access to video classes, document classes, quizzes and, if you are on a tutored course, the tutorials. Enjoy!',
    image: img7
  }
];

const HowDoISignUp = () => (
  <span>
    <h1 className='u-text-center'>Great! How do I sign up?</h1>
    <Accordian items={items} />
  </span>
);

export default HowDoISignUp;



// WEBPACK FOOTER //
// ./src/views/Main/Tour/HowDoISignUp/index.js